import { Form, Radio, Row, Col, InputNumber } from "antd";
import classNames from "classnames";
import { useCallback, useState } from "react";
import { TextContentEditor } from "../FormTerms/FormTermsConf";

const TEASER_POS_MAPPING = {
  rectangle: [
    "top-left",
    "top-center",
    "top-right",
    "center-left",
    "center-right",
    "bottom-left",
    "bottom-center",
    "bottom-right",
  ],
  circle: [
    "top-left",
    "top-center",
    "top-right",
    "center-left",
    "center-right",
    "bottom-left",
    "bottom-center",
    "bottom-right",
  ],
  corner: ["top-left", "top-right", "bottom-left", "bottom-right"],
};

const PagePositionSelector = ({ allowPos, value, onChange }) => {
  const [actPos, setActPos] = useState(value);

  const handleClick = useCallback(
    (e) => {
      const pos = e.target.dataset["pos"];
      if (allowPos.includes(pos)) {
        setActPos(pos);
        onChange && onChange(pos);
      }
    },
    [allowPos]
  );

  return (
    <div className="rip-mm-page-pos-wrapper" onClick={handleClick}>
      <div
        data-pos="top-left"
        className={classNames("rip-mm-page-top-left", {
          "allow-select": allowPos.includes("top-left"),
          active: actPos === "top-left",
        })}
      ></div>
      <div
        data-pos="top-center"
        className={classNames("rip-mm-page-top-center", {
          "allow-select": allowPos.includes("top-center"),
          active: actPos === "top-center",
        })}
      ></div>
      <div
        data-pos="top-right"
        className={classNames("rip-mm-page-top-right", {
          "allow-select": allowPos.includes("top-right"),
          active: actPos === "top-right",
        })}
      ></div>

      <div
        data-pos="center-left"
        className={classNames("rip-mm-page-center-left", {
          "allow-select": allowPos.includes("center-left"),
          active: actPos === "center-left",
        })}
      ></div>
      <div
        data-pos="center-center"
        className={classNames("rip-mm-page-center-center", {
          "allow-select": allowPos.includes("center-center"),
          active: actPos === "center-center",
        })}
      ></div>
      <div
        data-pos="center-right"
        className={classNames("rip-mm-page-center-right", {
          "allow-select": allowPos.includes("center-right"),
          active: actPos === "center-right",
        })}
      ></div>

      <div
        data-pos="bottom-left"
        className={classNames("rip-mm-page-bottom-left", {
          "allow-select": allowPos.includes("bottom-left"),
          active: actPos === "bottom-left",
        })}
      ></div>
      <div
        data-pos="bottom-center"
        className={classNames("rip-mm-page-bottom-center", {
          "allow-select": allowPos.includes("bottom-center"),
          active: actPos === "bottom-center",
        })}
      ></div>
      <div
        data-pos="bottom-right"
        className={classNames("rip-mm-page-center-left", {
          "allow-select": allowPos.includes("bottom-right"),
          active: actPos === "bottom-right",
        })}
      ></div>
    </div>
  );
};

export default () => {
  return (
    <>
      <Form.Item label="Shape" name="shape">
        <Radio.Group
          options={[
            { label: "Corner", value: "corner" },
            { label: "Rectangle", value: "rectangle", disabled: true },
            { label: "Circle", value: "circle", disabled: true },
          ]}
          defaultValue="rectangle"
          optionType="button"
        />
      </Form.Item>

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const shape = getFieldValue("shape");
          return (
            <Form.Item label="Teaser position" name="position">
              <PagePositionSelector allowPos={TEASER_POS_MAPPING[shape]} />
            </Form.Item>
          );
        }}
      </Form.Item>
      <Form.Item label="Size" name={"size"}>
        <InputNumber min={60} max={200} style={{ width: "100%" }} />
      </Form.Item>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item label="Close button distance" name="closeButtonDistance">
            <InputNumber min={0} max={100} style={{width: "100%"}} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Content padding" name="padding">
            <InputNumber min={0} max={100} style={{width: "100%"}} />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item name="content" label="Content">
        <TextContentEditor />
      </Form.Item>
    </>
  );
};
